import * as React from 'react'

import { Switch, Route } from 'react-router-dom'
import { PageNotFoundComponent } from '../PageNotFound/PageNotFound'
import { HelpComponent } from '../Help/Help'
import { SiteMasterContainer } from '../SiteConfig/SiteMasterContainer'
import { RouteComponentProps, Redirect } from 'react-router'
import { ReportListContainer } from '../ReportsList/ReportsListContainer'
import { AddReportContainer } from '../AddReport/AddReportContainer'
import { CalculationLogContainer } from '../Calculations/CalculationLogContainer'
import { SiteStoredSettings } from '../../common/LocalStorage'
import { IMessageService } from '../../common/IMessageService';
import {loadMarketList} from "../../rest-api/Market-api";
import Market from "../../model/Market";

export interface SiteRouteProps extends RouteComponentProps<{ siteKey: string }> {
  messageService: IMessageService
}
export interface ReportRouteProps  extends RouteComponentProps<{ market: string; reportGroup: string }> {}
export interface CalculationLogRouteProps extends RouteComponentProps<{ runIdentifier: string }> {
  messageService: IMessageService
}

export class Router extends React.Component<{ messageService: IMessageService }, { markets: Market[] }> {

  constructor(props: Readonly<{ messageService: IMessageService }>) {
    super(props);
    this.state = {
      markets: []
    }
  }

  componentDidMount() {
    loadMarketList().then(markets => {
      const filteredMarkets = markets.filter(m => !m.name.toLowerCase().includes("global"));
      this.setState({markets: filteredMarkets})
    });
  }

  render() {
    var selectedSite = SiteStoredSettings.GetSelectedSite();
    var siteMode = SiteStoredSettings.GetSiteMode();
    return (
      <Switch>
        {/*Component*/}
        <Route exact={true}    path="/help" render={() => <HelpComponent markets={this.state.markets} />} />
        <Route exact={true}    path="/reports" component={ReportListContainer} />
        <Route exact={true}    path="/site/configuration/:siteKey" render={() => <SiteMasterContainer messageService={this.props.messageService}/>} />
        <Route exact={true}    path="/site/downtime/:siteKey" render={() => <SiteMasterContainer messageService={this.props.messageService}/>} />
        <Route exact={true}    path="/reports/:market" component={ReportListContainer} />
        <Route exact={true}    path="/reports/:market/:reportGroup" component={ReportListContainer} />
        <Route exact={true}    path="/reports/:market/:reportGroup/new" component={AddReportContainer} />
        <Route exact={true}    path="/site/calculations/:runIdentifier" render={() => <CalculationLogContainer messageService={this.props.messageService}/>} />

        {/*Redirects*/}
        <Redirect exact={true} from='/' to={"/site/" + siteMode + "/" + selectedSite}/>
        <Redirect exact={true} path="/site" to={"/site/" + siteMode + "/" + selectedSite} />
        <Redirect exact={true} path="/site/configuration" to={"/site/configuration/" + selectedSite} />
        <Redirect exact={true} path="/site/downtime" to={"/site/downtime/" + selectedSite} />

        {/*Support legacy urls*/}
        <Redirect exact={true} path="/site-config/:siteKey" to={"/site/configuration/:siteKey"} />
        <Redirect exact={true} path="/downtimes" to={"/site/downtime"} />
        <Redirect exact={true} path="/downtimes/:siteKey" to={"/site/downtime/:siteKey"} />
        <Redirect exact={true} path="/sites" to={"/site/" + siteMode + "/" + selectedSite} />

        {/*Unknown url*/}
        <Route                 path="*" component={PageNotFoundComponent} />
      </Switch>
    );
  }
}
